module.exports = __webpack_public_path__ + "static/media/sorteio.57f4d22d.svg";